// extracted by mini-css-extract-plugin
export default {"container":"fyACm4","title":"taSvWw","textButton":"_hShgY"};